import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { DougBusinessCardStackBackgroundViewModel } from './doug-business-card-stack-background-view-model';
import { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-doug-business-card-stack-background',
  templateUrl: './doug-business-card-stack-background.component.html',
  styleUrls: ['./doug-business-card-stack-background.component.scss'],
  providers: [DougBusinessCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DougBusinessCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: DougBusinessCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
